import React, {useEffect,useState} from 'react'
import {auth, onAuthStateChanged} from "FirebaseInit";
function useAuthUser() {
  const user = auth.currentUser;
  const [login, setLogin] = useState(false)
  useEffect(() => {

    onAuthStateChanged(auth, () => {
      if (user) {
        setLogin(true)
      } else {
        setLogin(false)
      }
    });
  }, [user])
  return login
}

export {useAuthUser}